"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasketStatusMessage = exports.getBasketStatusMessageType = exports.getBasketState = void 0;
var Context_1 = require("../../Enums/Context");
var Basket_1 = require("../../Enums/Basket");
var Messages_1 = require("../../Enums/Messages");
var GroupDeliveryDay_1 = require("../DeliveryPoint/GroupDeliveryDay");
var getBasketState = function (basket, options) {
    var _a, _b, _c, _d, _e;
    var _f = options || { activeOrders: [], context: Context_1.Context.Basket }, activeOrders = _f.activeOrders, context = _f.context;
    if (!(basket === null || basket === void 0 ? void 0 : basket.groupDeliveryDay))
        return Basket_1.BasketState.Ok;
    var isSubscriptionContext = context === Context_1.Context.Subscription || context === Context_1.Context.SubscriptionBasket || context === Context_1.Context.SwitchSubscription;
    if ((isSubscriptionContext && ((_a = basket.groupDeliveryDay) === null || _a === void 0 ? void 0 : _a.isFullForSubscription)) || ((_b = basket.groupDeliveryDay) === null || _b === void 0 ? void 0 : _b.isFull)) {
        return Basket_1.BasketState.Full;
    }
    else if ((_c = basket.groupDeliveryDay) === null || _c === void 0 ? void 0 : _c.isTooLate) {
        return Basket_1.BasketState.TooLate;
    }
    else if (!((_d = basket.groupDeliveryDay) === null || _d === void 0 ? void 0 : _d.timeSlot) || !((_e = basket.groupDeliveryDay) === null || _e === void 0 ? void 0 : _e.isNextDeliveryAvailable)) {
        return Basket_1.BasketState.NotAvailable;
    }
    else if (basket.linkedOrder) {
        return Basket_1.BasketState.LinkedOrder;
    }
    else if ((activeOrders === null || activeOrders === void 0 ? void 0 : activeOrders.length) > 0) {
        var editableOrder = activeOrders.find(function (order) { return order.isEditable; });
        if (editableOrder) {
            return Basket_1.BasketState.DifferentDeliveryDay;
        }
        else {
            return Basket_1.BasketState.NonEditableOrder;
        }
    }
    return Basket_1.BasketState.Ok;
};
exports.getBasketState = getBasketState;
var getBasketStatusMessageType = function (basket, options) {
    var _a = options || { activeOrders: [], context: Context_1.Context.Basket }, activeOrders = _a.activeOrders, context = _a.context;
    var basketState = (0, exports.getBasketState)(basket, { activeOrders: activeOrders, context: context });
    if (basket.groupDeliveryDay && (0, GroupDeliveryDay_1.isGddDisabled)(basket.groupDeliveryDay, { context: context }))
        return Messages_1.MessageType.Error;
    switch (basketState) {
        case Basket_1.BasketState.Full:
        case Basket_1.BasketState.NotAvailable:
            return Messages_1.MessageType.Error;
        case Basket_1.BasketState.DifferentDeliveryDay:
        case Basket_1.BasketState.NonEditableOrder:
        case Basket_1.BasketState.TooLate:
            return Messages_1.MessageType.Warning;
        case Basket_1.BasketState.LinkedOrder:
        default:
            return Messages_1.MessageType.Success;
    }
};
exports.getBasketStatusMessageType = getBasketStatusMessageType;
var getBasketStatusMessage = function (basket, options) {
    var _a;
    if (!basket)
        return null;
    var _b = options || { activeOrders: [], context: Context_1.Context.Basket }, activeOrders = _b.activeOrders, context = _b.context;
    var basketState = (0, exports.getBasketState)(basket, { activeOrders: activeOrders, context: context });
    var type = (0, exports.getBasketStatusMessageType)(basket, { activeOrders: activeOrders, context: context });
    switch (basketState) {
        case Basket_1.BasketState.Full:
            return {
                text: '<b>Attention&nbsp;:</b> le jour de retrait sélectionné est complet. Merci de le modifier pour passer commande.',
                type: type,
            };
        case Basket_1.BasketState.TooLate:
            return {
                text: '<b>Information&nbsp;:</b> le jour de retrait sélectionné est la semaine prochaine. Les produits seront disponibles jeudi.',
                type: type
            };
        case Basket_1.BasketState.NotAvailable:
            return {
                text: '<b>Attention&nbsp;:</b> votre choix de livraison n’est plus disponible. Merci de le modifier pour passer commande.',
                type: type
            };
        case Basket_1.BasketState.LinkedOrder:
            return {
                text: 'Ce panier complètera votre <u>commande en cours</u> car leurs choix de livraison sont identiques.',
                type: type,
                redirect: {
                    name: 'mon-compte_orders_detail', params: { orderId: (_a = basket === null || basket === void 0 ? void 0 : basket.linkedOrder) === null || _a === void 0 ? void 0 : _a.id }
                }
            };
        case Basket_1.BasketState.DifferentDeliveryDay:
            return {
                text: 'Ce panier ne complètera pas votre <b><u>commande en cours,</u></b> mais en créera une nouvelle, car leurs choix de livraison sont différents.',
                type: type,
                redirect: {
                    name: 'mon-compte_orders'
                }
            };
        case Basket_1.BasketState.NonEditableOrder:
            return {
                text: 'Ce panier ne complètera pas votre <b><u>commande en cours,</u></b> mais en créera une nouvelle, car celle-ci n’est pas modifiable.',
                type: type,
                redirect: {
                    name: 'mon-compte_orders'
                }
            };
        default:
            return null;
    }
};
exports.getBasketStatusMessage = getBasketStatusMessage;
exports.default = { getBasketState: exports.getBasketState, getBasketStatusMessageType: exports.getBasketStatusMessageType, getBasketStatusMessage: exports.getBasketStatusMessage };
//# sourceMappingURL=BasketStatus.js.map